export default String.raw`.card-product{height:406px}.card-product__image{height:186px}.card-product__buttons .button__text{display:none}`